export default __webpack_public_path__ + "static/media/servicetype_md_192.bb22169e.png";